<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USE_YN')" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-5">
            <sui-yn-select ref="comboUseYn"
                       :selected="queryData.useYnValue"
                       :defaultOption="'all'"
                       :initialSelectedIndex="0" />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="comboSearchCond"
              :selected="queryData.COD_PORTL_SEARCH_COND"
              :pagedId="this.$options.name"
              codeId="COD_PORTL_SEARCH_COND"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
              style="width:58%"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="queryData.portalSearchText"
              maxlength="50"
              @keyup.enter="onClickSearch"
              @keyup="onKeyUpInput"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DEL_YN')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-yn-select
              ref="deleteYn"
              :selected="queryData.deleteYnValue"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>

          <div
            v-if="deviceApplyYn"
            class="col-xs-1"
          >
            <sui-input-label :label="$t('MSG_TXT_DVC_TYPE')" :required="false" :vertical="false"></sui-input-label>
          </div>
          <div
            v-if="deviceApplyYn"
            class="col-xs-5"
          >
            <sui-multi-select
              ref="deviceMultiDropdown"
              v-model="deviceSelectValue"
              :placeholder="placeholder"
              :options="deviceTypeList"
              :multiple="true"
              :closeOnSelect="false"
              :useAllOption="true"
            />
            <!-- <ur-multi-dropdown
              ref="deviceMultiDropdown"
              :items="deviceTypeList"
            /> -->
          </div>
        </div>
        <div
          v-if="superTenantYn"
          class="row"
        >
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_TENANT_ID')" />
          </div>
          <div 
            v-if="superTenantYn"
            class="col-xs-5"
          >
            <sui-custom-select
              ref="comboTenants"
              :selected="queryData.tenantId"
              :option-list="selectTenantList"
              @list-clicked="onSelectionChangedTenant"
              @selection-changed="onSelectionChangedTenant"
            />
          </div>
          <div
            v-if="!deviceApplyYn || !superTenantYn"
            class="col-xs-1 nodata"
          />
          <div
            v-if="!deviceApplyYn || !superTenantYn"
            class="col-xs-5 nodata"
          />
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SRCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="gridPortal"
        :columns="columnPortal"
        :dataset="'dsPortal'"
        :showDisplayCountControl="true"
        :initial-pagesize="5"
        @rowselect="onRowSelect"
      >
        <div class="btn_wrapR">
          <sui-button
            type="button"
            class="comm_btn_gridTop comm_ico_excel"
            @click="onClickExcelDownload"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>
        </div>
      </sui-grid>
      <div class="mrB30" />
      <sui-page-tab-box-type
        ref="tab"
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="onSetCurrentTabComponent"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
          :is="currentTabComponent"
          :selectedGridRowData="selectedGridRowData"
          :deviceApplyYn="deviceApplyYn"
          @onClickSearch="onClickSearch"
          @onGridClear="onGridClear"
        />
      </sui-page-tab-box-type>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';
import tab01 from './components/PGE_CMP_00025_T01.vue';

const dateTypeFields = ['firstRegistrationDTM', 'finalModificationDTM'];

export default {
  name: 'PGE_CMP_00025', // eslint-disable-line vue/name-property-casing
  components: {
    tab01,
  },
  extends: BasePage,
  data() {
    return {
      superTenantYn: this.$store.getters.userInfo.tenantId == utils.getConfigurationValue('YML_TENANT_ID_SUPER'),
      selectedGridRowData: {},
      tabItems: [
        {
          tabTitle: this.$t('MSG_TXT_PORTL'),
          component: tab01,
        },
      ],
      currentTabComponent: 'tab01',
      defaultTabIndex: 0,
      queryData: {
        deleteYnValue: {},
        tenantId: {
          label: '',
          key: null,
        },
        portalSearchText: '',
        COD_PORTL_SEARCH_COND: {
          label: this.$t('MSG_TXT_ALL'),
          key: 'ALL',
        },
        deviceTypeValue: 0,
        useYnValue:{
          label: this.$t('MSG_TXT_ALL'),
          key: 'ALL',
        },
      },
      selectTenantList: [{key:utils.getConfigurationValue('YML_TENANT_ID_SUPER'),label:'Super Tenant'}],
      deviceApplyYn: utils.getConfigurationValue('CFG_CMZ_DVC_TYPE_APPY_YN') === 'Y',
      deviceSelectValue: [],
      placeholder: this.$t('MSG_TXT_ALL'),
      searchFieldOldText: '',
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsPortal',
    type: 'local',
    datafields: [
      {
        name: 'tenantId',
        type: 'string',
        map: 'tenantId',
      },
      {
        name: 'portalId',
        type: 'string',
        map: 'portalId',
      },
      {
        name: 'portalName',
        type: 'string',
        map: 'portalName',
      },
      {
        name: 'deviceTypeCodeName',
        type: 'string',
        map: 'deviceTypeCodeName',
      },
      {
        name: 'portalContent',
        type: 'string',
        map: 'portalContent',
      },
      {
        name: 'useYn',
        type: 'string',
        map: 'useYn',
      },
      {
        name: 'deleteYn',
        type: 'string',
        map: 'deleteYn',
      },
      {
        name: 'firstRegistrationDTM',
        type: 'string',
        map: 'firstRegistrationDTM',
      },
      {
        name: 'firstRegistrationUserId',
        type: 'string',
        map: 'firstRegistrationUserId',
      },
      {
        name: 'firstRegistrationProgramId',
        type: 'string',
        map: 'firstRegistrationProgramId',
      },
      {
        name: 'finalModificationDTM',
        type: 'string',
        map: 'finalModificationDTM',
      },
      {
        name: 'finalModificationUserId',
        type: 'string',
        map: 'finalModificationUserId',
      },
      {
        name: 'finalModificationProgramId',
        type: 'string',
        map: 'finalModificationProgramId',
      },
      { type: 'string', name: 'firstRegistrationDisplayLanguageId', map: 'firstRegistrationDisplayLanguageId' },
      { type: 'string', name: 'firstRegistrationLoginId', map: 'firstRegistrationLoginId' },
      { type: 'string', name: 'firstRegistrationKnoxId', map: 'firstRegistrationKnoxId' },
      { type: 'string', name: 'firstRegistrationUserName', map: 'firstRegistrationUserName' },
      { type: 'string', name: 'firstRegistrationUserGlobalName', map: 'firstRegistrationUserGlobalName' },
      { type: 'string', name: 'firstRegistrationDepartmentName', map: 'firstRegistrationDepartmentName' },
      { type: 'string', name: 'firstRegistrationDepartmentEnglishName', map: 'firstRegistrationDepartmentEnglishName' },
      { type: 'string', name: 'finalModificationDisplayLanguageId', map: 'finalModificationDisplayLanguageId' },
      { type: 'string', name: 'finalModificationLoginId', map: 'finalModificationLoginId' },
      { type: 'string', name: 'finalModificationKnoxId', map: 'finalModificationKnoxId' },
      { type: 'string', name: 'finalModificationUserName', map: 'finalModificationUserName' },
      { type: 'string', name: 'finalModificationUserGlobalName', map: 'finalModificationUserGlobalName' },
      { type: 'string', name: 'finalModificationDepartmentName', map: 'finalModificationDepartmentName' },
      { type: 'string', name: 'finalModificationDepartmentEnglishName', map: 'finalModificationDepartmentEnglishName' },
    ],
    
  }],
  created() {
    this.columnPortal = [
      {
        text: this.$t('MSG_TXT_PORTL_ID'),
        datafield: 'portalId',
      },
      {
        text: this.$t('MSG_TXT_PORTL_NM'),
        datafield: 'portalName',
      },
      {
        text: this.$t('MSG_TXT_DVC_TYPE'),
        datafield: 'deviceTypeCodeName',
        width: '200px',
        hidden: !this.deviceApplyYn,
      },
      {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'useYn',
        width: '80px',
      },
      {
        text: this.$t('MSG_TXT_DEL_YN'),
        datafield: 'deleteYn',
        width: '80px',
      },
      {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'finalModificationUserName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1',
            type: 'link',
            datafieldMap: {
              userId: 'finalModificationUserId',
              userName: 'finalModificationUserName',
              userGlobalName: 'finalModificationUserGlobalName',
              departmentName: 'finalModificationDepartmentName',
              departmentEnglishName: 'finalModificationDepartmentEnglishName',
              displayLanguageId: 'finalModificationDisplayLanguageId',
              loginId: 'finalModificationLoginId',
              knoxId: 'finalModificationKnoxId',
            },
          }, this.dsPortal, this.$refs.gridPortal);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '200px',
      },
      {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: '170px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellDateLabel(row, column, value, htmlElement, {
          }, this.dsPortal, this.$refs.gridPortal);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
    ];
    this.deviceTypeList = [];
  },
  mounted() {
    // Tenant list
    http.request(this.$options.name, 'DTS_CMZ_00163')
      .then(res => {
        utils.forEach(res.data, obj => {
          this.selectTenantList.push({
            key: obj.tenantId,
            label: obj.tenantName,
          });
        });
      })
      .catch(error => {
        console.log(error);
      });
    this.loadDeviceCode();
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      const paramData = utils.getParameter(this, 'queryData');
      if (!utils.isEmpty(paramData)) {
        this.queryData = paramData;
        this.onClickSearch();
      }
    },
    loadDeviceCode() {
      http.getCodeList(this.pageId, ['COD_DVC_TYPE'], '').then(res => {
        utils.forEach(res['COD_DVC_TYPE'], (value, key) => {
          this.deviceTypeList.push(
            // { value: value.key, text: value.codeName }
            { key: value.key, label: value.codeName },
          );
          this.deviceSelectValue.push(
            { key: value.key, label: value.codeName },
          );
        });
      }).catch(err => {
        console.log(err);
      });
    },
    onClickSearch() {
      if(this.deviceApplyYn) {
        this.queryData.deviceTypeValue = this.calculateDeviceTypeValue();
      }
      const dataParams = {
        tenantId: utils.isEmpty(this.queryData.tenantId.key)?this.$store.getters.userInfo.tenantId:this.queryData.tenantId.key,
        deviceTypeValue: this.queryData.deviceTypeValue ? this.queryData.deviceTypeValue : 0,
        useYn : this.queryData.useYnValue.key,
        delelteYn: utils.trim(this.queryData.deleteYnValue.key) || '',
        portalSearchText: this.queryData.portalSearchText,
        portalSearchCond: this.queryData.COD_PORTL_SEARCH_COND.key,
      };
      http.request(this.contextPageId, 'DTS_CMP_00108', {
        query: dataParams,
      }).then(res => {
        // utils.dateformatToClientInArray(res.data, dateTypeFields);
        this.dsPortal.setRawData(res.data);
      });
    },
    onClickReset() {
      this.queryData.portalSearchText = '';
      if (this.deviceApplyYn) {
        // this.$refs.deviceMultiDropdown.selected = [];
        this.deviceSelectValue = [];
      }
      this.queryData.deviceTypeValue = 0;
      this.$refs.comboUseYn.reset();
      this.$refs.deleteYn.reset();
      this.$refs.comboSearchCond.reset();
    },
    onSetCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].component;
    },
    onClickExcelDownload() {
      const sPageId = this.contextPageId;
      const objGridColumns = this.columnPortal;
      const objGridDataset = this.dsPortal;
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `portal_management_${sToday}.xlsx`;
      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, {});
    },
    onRowSelect(event) {
      console.log(event);
      if (!utils.isEmpty(event.args.row)) {
        this.selectedGridRowData = event.args.row;
      } else {
        this.selectedGridRowData = {};
      }
    },
    onRowClick(event) {
      if (utils.isEmpty(this.selectedGridRowData)) {
        this.selectedGridRowData = event.args.row.bounddata;
      } else if (event.args.row.bounddata.uniqueid !== this.selectedGridRowData.uniqueid) {
        this.selectedGridRowData = event.args.row.bounddata;
      } else {
        this.selectedGridRowData = {};
        setTimeout(() => {
          this.$refs.gridPortal.$refs.grid.unselectrow(event.args.row.boundindex);
        }, 1);
      }
    },
    onSelectionChangedTenant() {
      this.onClickSearch();
    },
    onGridClear() {
      this.dsPortal.clearSelection();
    },
    calculateDeviceTypeValue() {
      let ret = 0;
      // const deviceSelectedList = this.$refs.deviceMultiDropdown.selected;
      // utils.forEach(deviceSelectedList, (item, key) => {
      // ret += Number(item.value);
      utils.forEach(this.deviceSelectValue, (item, key) => {
        ret += Number(item.key);
      });
      return ret;
    },
    onKeyUpInput() {      
      const searchFieldNewText = this.queryData.portalSearchText;

      if (utils.isEmpty(searchFieldNewText) === false) {
        if (utils.isExistSpecialChar(searchFieldNewText) === true) {
          this.conFirm('error', this.$t('MSG_ALT_NO_SPECL_CHAR'), null);
          this.queryData.portalSearchText = this.searchFieldOldText;
        } else {
          this.searchFieldOldText = searchFieldNewText;
        }
      }
    },
    conFirm(type, value, subValue) {
      utils.messageBox(type, value, subValue, this.onClose);
    },
  },
};
</script>

<style scoped>
</style>
